import { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";

export default function ProcessosCliente() {
  const [processos, setProcessos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/cliente_processos.php")
      .then(res => setProcessos(res.data))
      .catch(err => console.error("Erro processos cliente:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="p-6 text-slate-400">
        Carregando processos...
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold text-slate-100 mb-4">
        Meus Processos
      </h1>

      {processos.length === 0 && (
        <p className="text-sm text-slate-400">
          Nenhum processo disponível no momento.
        </p>
      )}

      <div className="space-y-4">
        {processos.map(p => (
          <div
            key={p.id}
            onClick={() => navigate(`/app/cliente/processos/${p.id}`)}
            className="
              cursor-pointer rounded-xl border border-[#1f2937]
              bg-[#121826] p-4 transition
              hover:bg-[#1a2133]
            "
          >
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-slate-100">
                Processo nº {p.numero}
              </p>

              <span
                className={`
                  rounded-full px-3 py-1 text-xs font-medium
                  ${
                    p.status === "Ativo"
                      ? "bg-green-500/10 text-green-400"
                      : "bg-slate-500/10 text-slate-300"
                  }
                `}
              >
                {p.status}
              </span>
            </div>

            <p className="mt-1 text-xs text-slate-400">
              {p.vara} • {p.comarca}
            </p>

            {p.ultima_movimentacao && (
              <p className="mt-3 text-sm text-slate-300">
                Última atualização: {p.ultima_movimentacao}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
